module.exports = __webpack_public_path__ + "static/media/calendar.374dbd8e.svg";